export enum AppFieldType {
  TEXT_BOX = 1,
  DATE_FIELD = 2,
  DROP_DOWN_FIELD = 3,
  TEXT_AREA = 4,
  LABEL = 5,
  FILE_INPUT = 6,
  RADIO_BUTTON = 7,
  CHECK_BOX = 8,
  CREATE_NEW = 'A',
}
